import { useEffect, useRef } from "react";
import { GoogleAuthProvider, signInWithCredential } from "firebase/auth";
import { Capacitor } from "@capacitor/core";
import { auth } from "../firebase";

// ✅ Flag global para garantir apenas UMA instância do GSI
let gsiInitialized = false;
let gsiPromptActive = false;

const GoogleOneTap = ({ onLoginSuccess }) => {
  const mountedRef = useRef(false);

  useEffect(() => {
    // Previne execução em plataforma nativa
    if (Capacitor.isNativePlatform()) return;

    // Previne se usuário já está logado
    if (auth.currentUser) {
      return;
    }

    // Previne múltiplas inicializações (React Strict Mode)
    if (gsiInitialized || gsiPromptActive) {
      return;
    }

    // Aguarda biblioteca carregar
    if (!window.google?.accounts?.id) {
      console.warn("[One Tap] Biblioteca GSI ainda não carregou");
      return;
    }

    // Marca como montado
    mountedRef.current = true;

    // Cancela qualquer prompt anterior
    try {
      window.google.accounts.id.cancel();
    } catch (e) {
      // Ignora erro se não houver prompt ativo
    }

    // Marca como inicializado ANTES de chamar initialize
    gsiInitialized = true;


    // Inicializa GSI
    window.google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
      auto_select: false,
      cancel_on_tap_outside: false, // ✅ Não fecha ao clicar fora
      context: "signin",
      ux_mode: "popup",
    });

    // Exibe o prompt apenas se ainda montado e sem prompt ativo
    if (mountedRef.current && !gsiPromptActive) {
      gsiPromptActive = true;
      
      window.google.accounts.id.prompt((notification) => {
        // Reseta flag quando prompt fecha
        gsiPromptActive = false;

        if (notification.isNotDisplayed()) {
        } else if (notification.isSkippedMoment()) {
        } else if (notification.isDismissedMoment()) {
        }
      });
    }

    // Cleanup ao desmontar
    return () => {
      mountedRef.current = false;
      
      // Só limpa se foi este componente que inicializou
      if (gsiInitialized) {
        try {
          window.google.accounts.id.cancel();
        } catch (e) {
          // Ignora erro
        }
        gsiInitialized = false;
        gsiPromptActive = false;
      }
    };
  }, []); // ✅ Array vazio - executa apenas uma vez

  const handleCredentialResponse = async (response) => {
    try {
      const credential = GoogleAuthProvider.credential(response.credential);
      const result = await signInWithCredential(auth, credential);


      // Marca flags como false após sucesso
      gsiInitialized = false;
      gsiPromptActive = false;

      if (onLoginSuccess) onLoginSuccess(result.user);
    } catch (error) {
      console.error("❌ Erro no One Tap:", error);
      gsiPromptActive = false;
    }
  };

  return null;
};

export default GoogleOneTap;